function linkHighlight(selectors) {
  const current = window.location.href;
  const [currentBaseRaw, currentHash = ''] = current.split('#');

  // 移除結尾的 /，但保留單獨的 /
  const normalize = (url) => {
    const base = url.split('#')[0];
    if (base.endsWith('/') && base.length > 1) {
      return base.slice(0, -1);
    }
    return base;
  };

  const currentBase = normalize(currentBaseRaw);

  // 支援字串或陣列
  const list = Array.isArray(selectors) ? selectors.join(',') : selectors;

  document.querySelectorAll(list).forEach((a) => {
    const href = a.href;
    const [hrefBaseRaw, hrefHash = ''] = href.split('#');
    const hrefBase = normalize(hrefBaseRaw);

    // 先清掉舊的 active（避免重複呼叫）
    a.classList.remove('active');

    // 1) 完全相同（含 hash） => 直接亮
    if (current === href) {
      a.classList.add('active');
      return;
    }

    // 2) 有 hash 的連結：base + hash 必須完全相同
    if (hrefHash) {
      if (hrefBase === currentBase && hrefHash === currentHash) {
        a.classList.add('active');
      }
      return;
    }

    // 3) 沒 hash 的連結：base 相同，且「目前網址沒有 hash」才亮
    if (!hrefHash && hrefBase === currentBase && currentHash === '') {
      a.classList.add('active');
      return;
    }

    // ❌ 不再處理「前綴比對」避免首頁誤判
  });
}

export { linkHighlight };
